var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCreateDirectoryIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 13H1V1h5l2 2h6v4M11 6v8m-4-4h8",
  stroke: "#662D91",
  strokeWidth: 2
})));
export { SvgCreateDirectoryIcon as ReactComponent };
export default __webpack_public_path__ + "75d3ddcf7174cbfabc302cd59ad9f182.svg";